<template>
	<tr v-if="!rate.separator">
		<td>{{rate.name}}</td>
		<td v-if="isCourse">{{ $t('components.rate.desc_course', {price: rate.price, price_currency: getCurrencySymbolFromString(rate.price_currency), appointment_count: rate.appointment_count, duration_in_minutes: rate.duration_in_minutes}) }}</td>
		<td v-else>	{{ $t('components.rate.desc_normal', {price: rate.price, price_currency: getCurrencySymbolFromString(rate.price_currency),  duration_in_minutes: rate.duration_in_minutes}) }}</td>
		<td class="text-right">
			<router-link  class="btn btn-default" :to="{ name: 'rate_detail', params: { id: rate.id }}">
				<i class="las la-edit"></i>{{ $t('common.edit') }}
			</router-link>
		</td>
	</tr>
	<tr v-else class="row-title">
		<td style="border:none;" colspan="3"><b>{{rate.separator_name}}</b></td>
	</tr>
</template>

<script>
import {RATE_TYPE} from "../../common/constants";
import {Utils} from "@/common/utils";

export default {
	name: "RateRow",
	props: {
		rate: {
			type: Object,
			require: true
		}
	},
    methods: {
        getCurrencySymbolFromString(currency) {
            return Utils.getCurrencySymbolFromString(currency)
        }
    },
	computed: {
		isCourse: function () {
			return this.rate.type === RATE_TYPE.COURSE
		}
	}
};
</script>